import { Button, Col, DatePicker, Form, Input, Row, Select, Space } from 'antd';
import moment from 'moment';
import TextArea from 'antd/lib/input/TextArea';
import { Schedule } from '../../modules/schedules';

const { Option } = Select;

interface ScheduleCreateUpdateComponentProps {
  schedule?: Schedule;
  onCreate: (data: any) => void;
  onCancel: () => void;
}

function ScheduleCreateUpdateComponent({
  schedule,
  onCancel,
  onCreate,
}: ScheduleCreateUpdateComponentProps) {
  const [form] = Form.useForm();
  // const [gongjongList, setGongjongList] = useState<any[]>();
  // const [subScheduleList, setSubScheduleList] = useState<Schedule[]>();
  // const [dependScheduleList, setDependScheduleList] = useState<Schedule[]>();
  let _schedule: any;
  // const schedules = useSelector(
  //   (state: RootState) => state.schedules.schedules.data,
  // );

  if (schedule) {
    _schedule = {
      ...schedule,
      startDate: moment(schedule.startDate, 'YYYY-MM-DD'),
      finishDate: moment(schedule.finishDate, 'YYYY-MM-DD'),

      // children: schedule.children.map((child: any) => {
      //   return { id: child.id, name: child.name, value: child.id };
      // }),
      // depends: schedule.depends.map((depend: any) => {
      //   return { id: depend.id, name: depend.name, value: depend.id };
      // }),
      children: schedule.children.map((child: any) => {
        return child.id;
      }),
      depends: schedule.depends.map((depend: any) => {
        return depend.id;
      }),
    };
  } else {
    _schedule = {
      complete: 0,
    };
  }

  // useEffect(() => {
  //   if (!mount) return;
  //   let children: any = [];

  //   children = [];
  //   for (const gongjong of invoiceCommon.gongjongList.sort((a: any, b: any) =>
  //     a.name.localeCompare(b.name),
  //   )) {
  //     children.push(
  //       <Option key={gongjong.id} value={gongjong.name}>
  //         {gongjong.name}
  //       </Option>,
  //     );
  //   }
  //   setGongjongList(children);

  //   return () => setMount(false);
  // }, [invoiceCommon, mount]);

  /*
  useEffect(() => {
    if (!mount) return;
    console.log(schedules);

    if (!schedules || schedules === undefined) return;
    const _schedules = [...schedules];
    let children: any = [];

    children = [];
    for (const sch of _schedules) {
      children.push(
        <Option key={sch.id} value={sch.id}>
          {sch.name}({sch.startDate} ~ {sch.finishDate})
        </Option>,
      );
    }
    setSubScheduleList(children);
    setDependScheduleList(children);

    // setOptions(
    //   invoiceCommon.gongjongList.map((gongjong: any) => {
    //     return { value: gongjong.name };
    //   }),
    // );

    return () => setMount(false);
  }, [schedules, mount]);
  */

  /*
  const [value, setValue] = useState('');
  const [options, setOptions] = useState<{ value: string }[]>([]);

  const onSearch = (searchText: string) => {
    console.log(searchText);
    // if (schedules === undefined || schedules === null) {
    //   setOptions([]);
    //   return;
    // }

    setOptions(
      // !searchText ? [] : [mockVal(searchText), mockVal(searchText, 2), mockVal(searchText, 3)],
      // child.includes(input.trim());
      !searchText
        ? invoiceCommon.gongjongList.map((gongjong: any) => {
            return { value: gongjong.name };
          })
        : // !searchText
          //   ? []
          invoiceCommon.gongjongList
            .filter((gongjong: any) =>
              gongjong.name.includes(searchText.trim()),
            )
            .map((gongjong: any) => {
              return { value: gongjong.name };
            }),

      // : schedules
      //     .filter((sch) => sch.name.includes(searchText.trim()))
      //     .map((sch) => {
      //       return { value: sch.name };
      //     }),
    );
  };

  const onSelect = (data: string) => {
    console.log('onSelect', data);
  };

  const onChange = (data: string) => {
    setValue(data);
  };
  */

  return (
    <>
      {/* <Row>
        <Col span={12}>
          <Title level={3}>{title}</Title>
        </Col>
      </Row> */}
      <Form
        form={form}
        layout="vertical"
        onFinish={onCreate}
        initialValues={_schedule}
      >
        {/* <Row justify="space-between"></Row>
        <Col span={11}></Col>
        <Col span={11}></Col> */}
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="name"
              label="공정명"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="예) 외벽 철거" style={{ width: '100%' }} />
              {/* <AutoComplete
                value={value}
                options={options}
                style={{ width: '100%' }}
                autoFocus
                onSelect={onSelect}
                onSearch={onSearch}
                onChange={onChange}
                placeholder="예) 외벽 철거"
              /> */}
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="complete"
              label="작업진행률"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }} placeholder="예) 20%">
                <Option value={0}>0%</Option>
                <Option value={20}>20%</Option>
                <Option value={40}>40%</Option>
                <Option value={60}>60%</Option>
                <Option value={80}>80%</Option>
                <Option value={100}>100%</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="startDate"
              label="시작일"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name="finishDate"
              label="종료일"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
        {/* <Form.Item name="gongjong" label="공사종류">
          <Select style={{ width: '100%' }} allowClear>
            {gongjongList}
          </Select>
        </Form.Item> */}

        <Form.Item name="description" label="설명">
          <TextArea rows={4} />
        </Form.Item>

        {/* <Form.Item name="children" label="하위공정">
          <Select
            style={{ width: '100%' }}
            placeholder="하위공정을 선택 하세요."
            showSearch
            mode="multiple"
            optionFilterProp="children"
            filterOption={(input: string, option: any) => {
              console.log(option);
              return (
                option.children.filter((child: any) => {
                  return child.includes(input.trim());
                }).length > 0
              );
            }}
          >
            {subScheduleList}
          </Select>
        </Form.Item>
        <Form.Item name="depends" label="의존공정">
          <Select
            style={{ width: '100%' }}
            placeholder="의존공정을 선택 하세요."
            showSearch
            mode="multiple"
            optionFilterProp="depends"
            filterOption={(input: string, option: any) => {
              return (
                option.children.filter((child: any) => {
                  return child.includes(input.trim());
                }).length > 0
              );
            }}
          >
            {dependScheduleList}
          </Select>
        </Form.Item> */}

        <Row justify="center">
          <Form.Item>
            <Space size="middle">
              <Button htmlType="button" onClick={onCancel}>
                취소
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100px' }}
              >
                확인
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
}

export default ScheduleCreateUpdateComponent;
